import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { HeadingSectionType01Component } from "../../heading-section/heading_section-type01/heading_section-type01.component";
import { TFMService } from 'app/mock-api/tfm.service';
import { FuseCardComponent } from '@fuse/components/card';
import { NgFor, NgStyle, CommonModule } from '@angular/common';
import { CountersType01Component } from "../../counter/counters-type01/counters-type01.component";
import { ScrollerSectionType01Component } from "../../scroller-section/scroller_section-type01/scroller_section-type01.component";
import { BannerSectionType01Component } from "../../banner-section/banner_section-type01/banner_section-type01.component";
import {ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
    selector: 'app-onboarding-type01',
    standalone: true,
    imports: [ReactiveFormsModule,
        MatIconModule,
        HeadingSectionType01Component,
        FuseCardComponent,
        NgStyle,
        NgFor,
        CommonModule,
        CountersType01Component,
        ScrollerSectionType01Component,
        BannerSectionType01Component,
    ],
    templateUrl: './onboarding-type01.component.html',
    styleUrl: './onboarding-type01.component.scss',
})
export class OnboardingType01Component {
    public view: any = {};
    form: FormGroup;

    constructor(private router: Router,private fb: FormBuilder, private _tfmService: TFMService) {}

    ngOnInit(): void {
        this.form = this.fb.group({
            title: ['', Validators.required],
            name: ['', Validators.required],
            surname: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            phone: [
                '',
                [Validators.required, Validators.pattern('^[0-9]{10}$')],
            ],
            city: ['', Validators.required],
        });
       this._tfmService.getSite().then((res) => {
           this.view.site = res;
           this._tfmService.log(this.view);
       });
    }

    submitForm() {
        if (this.view.site?.id == 146) {
            const formData = this.form.value;

            if (this.view.site.id == 146) {
                const subject = `New member request from ${formData.name} ${formData.surname}`;
                const body = `
                  <table>
                  <tr><td><strong>Name</strong></td><td>${formData.name} ${formData.surname}</td></tr>
                  <tr><td><strong>Email</strong></td><td>${formData.email}</td></tr>
                  <tr><td><strong>Phone</strong></td><td>${formData.phone}</td></tr>
                  <tr><td><strong>City</strong></td><td>${formData.city}</td></tr>
                  </table>
              `;


                this._tfmService.sendEmail(subject, body, 'franz@xltravel.co.za', 'Franz Von Wielligh').subscribe((res) => {
                        console.log('Email sent successfully!', res);
                        this.router.navigate(['/confirmation/become-a-member']);
                    });
            }
        }
    }
}


